var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-popup',{attrs:{"activator-icon":"fas fa-info-circle","open-hover":"","activator-small":""}},[_c('base-text',{attrs:{"value":_vm.alertMessage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }